import {useGrpcRequest} from '@aboutyou/data-fetcher';
import {CampaignsService_SubmitCRMEventTokenLazy} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/campaigns/v1/service.grpc.lazy';

export const useSubmitCRMEventToken = (jwtToken: string | null) => {
  return useGrpcRequest(CampaignsService_SubmitCRMEventTokenLazy, {
    crmEventToken: jwtToken ?? '',
  });
};
